import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b40f272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registerWrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wel" }, "VolcanO", -1))
const _hoisted_3 = { style: {"margin":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_CellGroup = _resolveComponent("CellGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      onSubmit: _ctx.register.onSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CellGroup, { inset: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_Field, {
              modelValue: _ctx.register.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.register.username) = $event)),
              name: "username",
              label: "用户名",
              placeholder: "用户名",
              rules: [{ required: true, message: '请填写用户名' }]
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Field, {
              modelValue: _ctx.register.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.register.password) = $event)),
              type: "password",
              name: "password",
              label: "密码",
              placeholder: "密码",
              rules: [{ required: true, message: '请填写密码' }]
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            loading: _ctx.register.loading,
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 立即注册 ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createElementVNode("div", {
      class: "toLogin",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.register.toLogin && _ctx.register.toLogin(...args)))
    }, "已有账号？去登录")
  ]))
}